const INITIAL_STATE = {
    presaleId: null,
    timeline: null,
    clicks: null,
    ctr: null,
    impressions: null,
};

export default function chartData(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'timeline':
            return {
                ...state,
                timeline: action.value,
            };
        case 'impressions':
            return {
                ...state,
                impressions: action.value,
            };
        case 'ctr':
            return {
                ...state,
                ctr: action.value,
            };
        case 'clicks':
            return {
                ...state,
                clicks: action.value,
            };
        default:
            return state;
    }
}
